const CANONICAL_SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function isCanonicalSlug(value: string): boolean {
  return CANONICAL_SLUG_RE.test(value);
}

export function parseCanonicalSlug(value: string | null | undefined): string | null {
  if (!value) return null;
  return isCanonicalSlug(value) ? value : null;
}

